<template>
  <div>
    <RfPromoDetailsInfoRow v-if="path" title="Dimensions">
      <template #promodetail>
        <div>
          {{ settings.width }} x {{ settings.height }}
          <br />
          <div v-if="path.device_type === 'web' && settings.m_width && settings.m_height">
            Mobile: {{ settings.m_width }} x {{ settings.m_height }}
          </div>
        </div>
        <div class="pd-info-edit">
          <RfButton
            iconSize="16"
            title="edit"
            icon="md:edit"
            color="accent"
            size="x-small"
            variant="text"
            :disabled="editDisabled"
            @click="showDimensionDialog"
          />
        </div>
      </template>
    </RfPromoDetailsInfoRow>
    <v-dialog
      v-model="showDimensionInfoDialog"
      width="700"
      contentClass="show-promo-details-actions"
      persistent
    >
      <v-card flat>
        <v-card-title class="headline">Dimensions</v-card-title>
        <v-card-text>
          <RfZoneId ref="placementZone" :model="path" />
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn
            size="large"
            class="cancel-btn"
            variant="outlined"
            width="100px"
            @click="closeDialog"
            >Cancel</v-btn
          >
          <v-btn
            size="large"
            :disabled="!isZoneIsValid"
            width="200px"
            color="primary"
            variant="flat"
            @click="submitConfiguration(path)"
          >
            <v-icon size="small" start>md:save</v-icon>Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RfPromoDetailsInfoRow from "@/components/RfPromotions/RfPromoDetailsInfoRow.vue";
import RfZoneId from "@/components/RfCommonCards/RfZoneId.vue";
import RfButton from "@/components/buttons/RfButton.vue";
import { cloneDeep } from "lodash-es";
import { useToastsStore } from "@/pinia/toastsStore";
import { ref } from "vue";
import { usePromptStore } from "@/pinia/promptStore";

export default {
  name: "RfZoneDimension",
  components: { RfPromoDetailsInfoRow, RfZoneId, RfButton },
  props: ["path", "editDisabled"],
  setup: () => ({
    placementZone: ref(),
    toastsStore: useToastsStore(),
    promptStore: usePromptStore(),
  }),
  data: () => ({ showDimensionInfoDialog: false }),
  computed: {
    settings() {
      if (this.path) return this.path.settings;
      return {};
    },
    isZoneIsValid() {
      return this.placementZone?.isValid;
    },
  },
  methods: {
    closeDialog() {
      this.showDimensionInfoDialog = false;
    },
    showDimensionDialog() {
      this.showDimensionInfoDialog = true;
    },
    async submitConfiguration(item) {
      try {
        const newPath = cloneDeep(item);
        if (this.$refs.placementZone) {
          this.$refs.placementZone.fillModel(newPath);
        }
        this.showDimensionInfoDialog = false;
        await this.promptStore.updatePathGroup({ appId: this.$route.params.aid, model: newPath });
        this.toastsStore.create({ type: "success", body: "Zone updated successfully" });
      } catch (e) {
        this.toastsStore.create({ type: "error", body: e.message });
      }
    },
  },
};
</script>
